import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for TopicPlan page */
export default class HomePageOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    includeTlm: PropTypes.bool.isRequired,
    run: PropTypes.bool.isRequired,
    tracker: PropTypes.string,
    primaryEntity: PropTypes.string
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const { tracker, primaryEntity } = this.props
    const debug = false
    return (
      <Joyride
        steps={this._steps(tracker, primaryEntity)}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps (tracker, primaryEntity) {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Attention Tracker for {tracker}!<br/><br/>This dashboard tracks cross-platform engagement while benchmarking versus competitive and/or ‘like’ content.<br/></p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>The feature chart maps engagement with {primaryEntity} leading up to launch day. Benchmarks provide insight into the relative performance of different items.<br/>Hover over the marked points on the graph to see which video(s) are driving spikes in engagement.</p>),
        target: '#dailyEngagement'
      },
      {
        ...common,
        content: (<p>The ‘Teasers and Trailers’ module highlights key video content related to {primaryEntity} within the launch window.<br/><br/>The ‘Top Terms’ module shows the top trending keywords in comments related to the selected title.<br/><br/>Let's Go!</p>),
        target: '#teasersAndWhatsNew'
      }
    ]

    return steps
  }
}
